'use client';
import 'react';

const remToPx = (multiplier) => {
    if (typeof document === 'undefined' || typeof getComputedStyle === 'undefined')
        return 16 * multiplier;
    if (!document || !getComputedStyle)
        return 16 * multiplier;
    return multiplier * parseFloat(getComputedStyle(document.documentElement).fontSize);
};

export { remToPx };
